import { render, staticRenderFns } from "./CardTarjaEnqueteSelecaoSportvQRCODE.vue?vue&type=template&id=126f77ae&scoped=true"
import script from "./CardTarjaEnqueteSelecaoSportvQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSelecaoSportvQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSelecaoSportvQRCODE.vue?vue&type=style&index=0&id=126f77ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f77ae",
  null
  
)

export default component.exports